export function isDefined<T>(value: T): boolean {
  return value !== undefined && value !== null;
}
